export const scrollToForm = (e) => {
  e.preventDefault();
  const el = document.getElementById('contact-us');
  const top = el.getBoundingClientRect().top + window.pageYOffset - 100;

  el.scrollIntoView({
    top,
    behavior: 'smooth', // smooth scroll
  });
};

export default scrollToForm;
